import type { TFunction } from 'i18next';

// Mirrors the `draft` block of a desk in backend/config/config.js.
export interface DraftConfig {
  statusId: number;
  requestTypeIds: string[];
  submitTransitionId: number;
  tabLabel?: 'To complete';
  submitLabel?: 'Submit for validation';
}

interface DeskConfigLike {
  draft?: DraftConfig | null;
}

type RequestTypeId = string | number | null | undefined;

interface IssueLike {
  fields?: {
    status?: { id?: string | number };
    customfield_10010?: { requestType?: { id?: RequestTypeId } };
  };
  mappedFields?: { requestType?: { requestType?: { id?: RequestTypeId } } };
}

export const getDraftConfig = (
  config: DeskConfigLike | null | undefined,
  requestTypeId: RequestTypeId
): DraftConfig | null => {
  const draft = config?.draft;
  if (!draft || requestTypeId == null) return null;
  return draft.requestTypeIds.includes(String(requestTypeId)) ? draft : null;
};

export const isDraftIssue = (
  issue: IssueLike | null | undefined,
  config: DeskConfigLike | null | undefined
): boolean => {
  const requestTypeId =
    issue?.mappedFields?.requestType?.requestType?.id ?? issue?.fields?.customfield_10010?.requestType?.id;
  const draft = getDraftConfig(config, requestTypeId);
  return draft != null && Number(issue?.fields?.status?.id) === draft.statusId;
};

// Config labels map to literal translation keys (i18n Jira-integrity guard).
export const getDraftTabLabel = (t: TFunction, draft: DraftConfig | null | undefined): string =>
  draft?.tabLabel === 'To complete' ? t('To complete') : t('Drafts');

export const getDraftSubmitLabel = (t: TFunction, draft: DraftConfig | null | undefined): string =>
  draft?.submitLabel === 'Submit for validation' ? t('Submit for validation') : t('Submit');
